import {
  MessageType,
  Sender,
  Body as MessageBody,
} from '@wix/ambassador-innovation-widget-v1-message/types';

export * as WidgetApi from '@wix/ambassador-innovation-widget-v1-message/types';

type NonEmptyArray<T> = [T, ...T[]];

export interface Message {
  id: string;
  createdDate?: number;
  sender?: Sender;
  conversationId?: string | null;
  answerTo?: string | null;
  triggerId?: string | null;
  messageType?: MessageType;
  body?: MessageBody;
  inboxId?: string | null;
  metaSiteId?: string | null;
  inboxConversationId?: string | null;
  visitorOptions?: string[];
  assistantActions?: string[];
}

export const enum AssistantAction {
  AddToCurrentCart = 'AddToCurrentCart',
  UpdateCurrentCart = 'UpdateCurrentCart',
  RemoveLineItemsFromCurrentCart = 'RemoveLineItemsFromCurrentCart',
  UpdateCurrentCartLineItemQuantity = 'UpdateCurrentCartLineItemQuantity',
}

export interface MessageWithVisitorOptions extends Message {
  visitorOptions: NonEmptyArray<string>;
}

export const hasVisitorOptions = (
  message: Message,
): message is MessageWithVisitorOptions =>
  (message.visitorOptions?.length ?? 0) > 0;

export interface MessageWithAssistantActions extends Message {
  assistantActions: NonEmptyArray<string>;
}

export const hasAssistantActions = (
  message: Message,
): message is MessageWithAssistantActions =>
  (message.assistantActions?.length ?? 0) > 0;

export interface MessageWithBody extends Message {
  body: MessageBodyWithText;
}

export interface MessageBodyWithText extends MessageBody {
  mainText: string;
}

export const hasBodyWithText = (message: Message): message is MessageWithBody =>
  !!message.body &&
  typeof message.body.mainText === 'string' &&
  message.body.mainText.trim().length > 0;
